export * from './authorityDossier.component';
